export const calculateTotalRfis = (rfisRequested, rfisDirected, allRfis) => {
  return allRfis?.length || rfisRequested.length + rfisDirected.length;
};

export const calculateStatusCounts = (rfisRequested, rfisDirected, allRfis) => {
  const counts = {};
  const allRfis2 =
    allRfis.length > 0 ? allRfis : [...rfisRequested, ...rfisDirected];

  allRfis2.forEach((rfi) => {
    counts[rfi.status] = (counts[rfi.status] || 0) + 1;
  });

  return counts;
};

export const calculateOpenRfis = (rfisRequested, rfisDirected, allRfis) => {
  const openStatuses = ["In Progress", "Submitted and waiting", "Re-assigned"];
  const allRfis2 =
    allRfis.length > 0 ? allRfis : [...rfisRequested, ...rfisDirected];
  return allRfis2.filter((rfi) => openStatuses.includes(rfi.status)).length;
};

export const calculateCompletedRfis = (
  rfisRequested,
  rfisDirected,
  allRfis
) => {
  const allRfis2 =
    allRfis.length > 0 ? allRfis : [...rfisRequested, ...rfisDirected];
  return allRfis2.filter((rfi) => rfi.status === "Completed").length;
};

export const calculateRequestersMetrics = (
  rfisRequested,
  rfisDirected,
  allRfis
) => {
  const requesters = {};
  const allRfis2 =
    allRfis.length > 0 ? allRfis : [...rfisRequested, ...rfisDirected];

  allRfis2.forEach((rfi) => {
    const email = rfi.requestor_email;
    if (!requesters[email]) {
      requesters[email] = {
        name: rfi.requestor_name,
        total: 0,
        open: 0,
        completed: 0,
      };
    }

    requesters[email].total++;
    if (rfi.status === "Completed") {
      requesters[email].completed++;
    } else {
      requesters[email].open++;
    }
  });

  return Object.values(requesters);
};

export const calculateDirectedToMetrics = (
  rfisRequested,
  rfisDirected,
  allRfis
) => {
  const directed = {};
  const allRfis2 =
    allRfis.length > 0 ? allRfis : [...rfisRequested, ...rfisDirected];

  allRfis2.forEach((rfi) => {
    const email = rfi.directed_to_email;
    if (email && rfi.status !== "Completed") {
      if (!directed[email]) {
        directed[email] = {
          count: 0,
          rfis: [],
        };
      }

      directed[email].count++;
      directed[email].rfis.push(rfi.ID);
    }
  });

  return directed;
};

export const calculatePendingDirectedTotal = (directedToMetrics) => {
  return Object.values(directedToMetrics).reduce(
    (total, item) => total + item.count,
    0
  );
};

export const calculateAllMetrics = (rfisRequested, rfisDirected, allRfis) => {
  const directedToMetrics = calculateDirectedToMetrics(
    rfisRequested,
    rfisDirected,
    allRfis
  );

  return {
    totalRfis: calculateTotalRfis(rfisRequested, rfisDirected, allRfis),
    statusCounts: calculateStatusCounts(rfisRequested, rfisDirected, allRfis),
    openRfis: calculateOpenRfis(rfisRequested, rfisDirected, allRfis),
    completedRfis: calculateCompletedRfis(rfisRequested, rfisDirected, allRfis),
    requestersMetrics: calculateRequestersMetrics(
      rfisRequested,
      rfisDirected,
      allRfis
    ),
    directedToMetrics,
    pendingDirectedTotal: calculatePendingDirectedTotal(directedToMetrics),
  };
};
